import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ResourceStatsProps {
  stats: {
    totalResources: number;
    totalDownloads: number;
    averageRating: number;
    newThisWeek: number;
  };
}

const ResourceStats = ({ stats }: ResourceStatsProps) => {
  const statItems = [
    {
      icon: 'FolderIcon',
      label: 'Total Resources',
      value: stats.totalResources.toLocaleString(),
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      icon: 'ArrowDownTrayIcon',
      label: 'Total Downloads',
      value: stats.totalDownloads.toLocaleString(),
      color: 'text-accent',
      bgColor: 'bg-accent/10',
    },
    {
      icon: 'StarIcon',
      label: 'Average Rating',
      value: stats.averageRating.toFixed(1),
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
    {
      icon: 'SparklesIcon',
      label: 'New This Week',
      value: stats.newThisWeek.toString(),
      color: 'text-secondary',
      bgColor: 'bg-secondary/10',
    },
  ];

  return (
    <div data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:46:4" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="46" data-component-end-line="58" data-component-file="ResourceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20lg%3Agrid-cols-4%20gap-4%20mb-6%22%7D" className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statItems.map((stat) => (
        <div data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:48:8" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="48" data-component-end-line="56" data-component-file="ResourceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-card%20rounded-xl%20shadow-md%20p-5%20hover%3Ashadow-brand%20transition-shadow%22%7D" key={stat.label} className="bg-card rounded-xl shadow-md p-5 hover:shadow-brand transition-shadow">
          <div data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:49:10" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="49" data-component-end-line="53" data-component-file="ResourceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20mb-3%22%7D" className="flex items-center gap-3 mb-3">
            <div data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:50:12" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="50" data-component-end-line="52" data-component-file="ResourceStats.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`p-2 ${stat.bgColor} rounded-lg`}>
              <Icon data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:51:14" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="51" data-component-end-line="51" data-component-file="ResourceStats.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={stat.icon as any} size={20} variant="solid" className={stat.color} />
            </div>
          </div>
          <p data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:54:10" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="54" data-component-end-line="54" data-component-file="ResourceStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-2xl%20font-heading%20font-bold%20text-foreground%20mb-1%22%7D" className="text-2xl font-heading font-bold text-foreground mb-1">{stat.value}</p>
          <p data-component-id="src/app/resource-discovery-center/components/ResourceStats.tsx:55:10" data-component-path="src/app/resource-discovery-center/components/ResourceStats.tsx" data-component-line="55" data-component-end-line="55" data-component-file="ResourceStats.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%7D" className="text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ResourceStats;